/* eslint-disable no-unused-vars */
import { Card, Grid, Typography } from '@mui/material';
import { ReactComponent as ArrowDown } from 'assets/icons/arrowDown.svg';
import { ReactComponent as Green } from 'assets/icons/green.svg';
import { ReactComponent as Red } from 'assets/icons/red.svg';
import { ReactComponent as Yellow } from 'assets/icons/yellow.svg';
import VectorDown from 'assets/images/VectorDown.png';
import VectorUp from 'assets/images/vector_up.png';
import PropTypes from 'prop-types';
import ArrowDownIcon from 'assets/icons/ArrowDownIcon.svg';

import { Link } from 'react-router-dom';
import {
  bgGreen,
  displayFlex,
  displayFlexColumn,
  fontsize10,
  fontsize15,
  fontsize16,
  fontsize32,
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import {
  centerContent,
  forCastCard,
  gray,
  medium,
  postCntl,
} from './ForecastCard.style';

const UpVector = () => {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.02448 11.4633C1.19415 11.6155 1.42726 11.701 1.67046 11.7002H6.40909C6.77873 11.7002 7.07841 11.9619 7.07841 12.2848V25.2283C7.07841 25.661 7.47993 26.0117 7.97525 26.0117H17.1982C17.6935 26.0117 18.095 25.661 18.095 25.2283V12.2848C18.095 11.9619 18.3947 11.7002 18.7644 11.7002H23.5164C24.0116 11.7083 24.4207 11.3643 24.43 10.9318C24.4347 10.7152 24.3365 10.5066 24.1589 10.3556L13.2359 0.81452C13.0698 0.667084 12.8436 0.583008 12.6068 0.580652C12.3653 0.579885 12.1337 0.664181 11.9642 0.81452L1.0413 10.3556C0.686468 10.6574 0.678938 11.1533 1.02448 11.4633Z"
        fill="#10D35E"
      />
    </svg>
  );
};

const DownVector = () => {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.02448 11.4633C1.19415 11.6155 1.42726 11.701 1.67046 11.7002H6.40909C6.77873 11.7002 7.07841 11.9619 7.07841 12.2848V25.2283C7.07841 25.661 7.47993 26.0117 7.97525 26.0117H17.1982C17.6935 26.0117 18.095 25.661 18.095 25.2283V12.2848C18.095 11.9619 18.3947 11.7002 18.7644 11.7002H23.5164C24.0116 11.7083 24.4207 11.3643 24.43 10.9318C24.4347 10.7152 24.3365 10.5066 24.1589 10.3556L13.2359 0.81452C13.0698 0.667084 12.8436 0.583008 12.6068 0.580652C12.3653 0.579885 12.1337 0.664181 11.9642 0.81452L1.0413 10.3556C0.686468 10.6574 0.678938 11.1533 1.02448 11.4633Z"
        fill="#F93939"
      />
    </svg>
  );
};
export const RateIcon = () => {
  return (
    <svg
      width="40"
      height="34"
      viewBox="0 0 40 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7342 15.2142C18.6898 15.1643 18.4999 14.9757 18.3437 14.7999C17.3614 13.7698 15.7536 11.0825 15.2628 9.67595C15.184 9.46234 15.0171 8.92229 15.0063 8.63375C15.0063 8.35726 15.0615 8.0937 15.1733 7.84219C15.3294 7.52867 15.5752 7.27717 15.8654 7.13935C16.0667 7.05064 16.6693 6.91283 16.68 6.91283C17.3392 6.77502 18.4103 6.69922 19.594 6.69922C20.7217 6.69922 21.7492 6.77502 22.4184 6.88785C22.4291 6.90077 23.1779 7.03858 23.4343 7.18931C23.9029 7.46579 24.1938 8.00584 24.1938 8.58379V8.63375C24.1824 9.01014 23.8914 9.8017 23.8807 9.8017C23.3892 11.1324 21.8602 13.7577 20.8442 14.8129C20.8442 14.8129 20.5832 15.11 20.4201 15.2392C20.1858 15.4408 19.8956 15.5407 19.6055 15.5407C19.2816 15.5407 18.9799 15.4278 18.7342 15.2142Z"
        fill="#112347"
      />
      <path
        d="M0 28.6817C0 25.9472 2.21674 23.7305 4.95122 23.7305H13.0973V33.6329H4.95122C2.21674 33.6329 0 31.4162 0 28.6817Z"
        fill="#3DD856"
      />
      <path
        d="M39.2002 28.6816C39.2002 31.4161 36.9835 33.6328 34.249 33.6328H26.1029V23.7304H34.249C36.9835 23.7304 39.2002 25.9471 39.2002 28.6816Z"
        fill="#E45857"
      />
      <rect
        x="13.0059"
        y="23.7305"
        width="13.0973"
        height="9.90244"
        fill="#EBCB38"
      />
    </svg>
  );
};
function ForecastCardInspected(props) {
  const { title, showProgressBar, data, response } = props;
  const Colour = data?.inspectedCountIndicator;
  // const inspectedVariation = Number(data?.inspectedCountVariation)
  return (
    <Card sx={forCastCard}>
      {title ? (
        <Typography sx={{ ...poppins600, color: '#26344E' }}>
          {title}
        </Typography>
      ) : null}
      <Typography
        sx={displayFlex}
        style={{
          justifyContent: 'space-between',
          padding: '20px 0px',
        }}
      >
        <Typography sx={centerContent}>
          <Typography sx={{ ...poppins600, ...fontsize32 }}>
            {data?.inspectedCountForecast === '' || response == -1
              ? 0
              : data?.inspectedCountForecast}
          </Typography>
          <Typography style={{ ...gray }} sx={{ ...poppins400, ...fontsize15 }}>
            {data?.week === '' || response == -1 ? 'week 0' : data?.week}
          </Typography>
        </Typography>
        <Typography
          sx={centerContent}
          style={{
            justifyContent: 'flex-end',
          }}
        >
          <Typography
            sx={{
              ...poppins500,
              ...fontsize16,
              ...bgGreen,
              ...postCntl,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '3px',
              marginBottom: '-7px',
            }}
          >
            <Typography
              sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}
            >
              <Typography
                sx={{
                  ...poppins500,
                  // ...fontsize32,
                  fontSize: '16px',
                  color: Colour == 'positive' ? '#10D35E' : '#F93939',
                }}
              >
                {data?.inspectedCountVariation === '' || response == -1
                  ? 0
                  : data?.inspectedCountVariation}
              </Typography>
              {response === 1 && (
                <Typography>
                  {Colour == 'positive' ? <UpVector /> : <DownVector />}
                  {/* <img
                  src={Colour == "positive" ? VectorUp : VectorDown}
                  width={25}
                  height={25}
                  alt="Live"
                /> */}
                </Typography>
              )}
            </Typography>
          </Typography>
          <Typography style={{ ...gray }} sx={{ ...poppins400, ...fontsize15 }}>
            Variation
          </Typography>
        </Typography>
        <Typography sx={centerContent}>
          <Typography sx={{ ...poppins600, ...fontsize32 }}>
            {data?.marketAvgInspectedCount === '' || response == -1
              ? 0
              : data?.marketAvgInspectedCount.toFixed(2)}
          </Typography>
          <Typography style={{ ...gray }} sx={{ ...poppins400, ...fontsize15 }}>
            Market Avg
          </Typography>
        </Typography>
      </Typography>
      {showProgressBar ? (
        <Grid
          sx={centerContent}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            textAlign: 'revert',
            justifyContent: 'space-between',
            backgroundColor: '#FBFAFE',
            padding: '5px 0px',
            marginBottom: '10px',
          }}
        >
          <Grid
            xs={3}
            style={{
              alignItems: 'center',
            }}
            sx={displayFlexColumn}
          >
            {/* <Typography sx={displayFlex}>
              <ArrowDown height={9} width={9} />
            </Typography>
            <Typography>
              <Green />
              <Yellow />
              <Red />
            </Typography> */}
            {/* <RateIcon/> */}
            <Typography
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: '-15px',
                // gap:"-5px"
                // padding:"10px"
              }}
            >
              <Typography>
                <img
                  src={ArrowDownIcon}
                  alt="Arrowdown"
                  style={{ marginTop: '12px' }}
                />
              </Typography>
              <Grid sx={{ display: 'flex' }}>
                <Typography
                  sx={{
                    height: '10px',
                    width: '12px',
                    background: '#3DD856',
                    borderTopLeftRadius: '5px',
                    borderBottomLeftRadius: '5px',
                  }}
                ></Typography>
                <Typography
                  sx={{ height: '10px', width: '12px', background: '#EBCB38' }}
                ></Typography>
                <Typography
                  sx={{
                    height: '10px',
                    width: '12px',
                    background: '#E45857',
                    borderTopRightRadius: '5px',
                    borderBottomRightRadius: '5px',
                  }}
                ></Typography>
              </Grid>
            </Typography>
          </Grid>
          <Grid
            style={{ color: '#000000' }}
            sx={{ ...poppins300, ...fontsize10 }}
            xs={9}
          >
            The accuracy of this estimate range is rate
            <span>
              <strong style={{ fontWeight: '600' }}> Medium. </strong>
            </span>
            <span>
              <Link href="a" style={{ ...medium }}>
                Learn more.
              </Link>
            </span>
          </Grid>
        </Grid>
      ) : null}
    </Card>
  );
}

function ForecastCardInterested(props) {
  const { title, showProgressBar, data, response } = props;
  const Colour = data?.interestedCountIndicator;
  return (
    <Card sx={forCastCard}>
      {title ? (
        <Typography sx={{ ...poppins600, color: '#26344E' }}>
          {title}
        </Typography>
      ) : null}
      <Typography
        sx={displayFlex}
        style={{
          justifyContent: 'space-between',
          padding: '20px 0px',
        }}
      >
        <Typography sx={centerContent}>
          <Typography sx={{ ...poppins600, ...fontsize32 }}>
            {data?.interestedCountForecast === '' || response == -1
              ? 0
              : data?.interestedCountForecast}
          </Typography>
          <Typography style={{ ...gray }} sx={{ ...poppins400, ...fontsize15 }}>
            {data?.week === '' || response == -1 ? 'week 0' : data?.week}
          </Typography>
        </Typography>
        <Typography
          sx={centerContent}
          style={{
            justifyContent: 'flex-end',
          }}
        >
          <Typography
            sx={{
              ...poppins500,
              ...fontsize16,
              ...bgGreen,
              ...postCntl,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '3px',
              marginBottom: '-7px',
            }}
          >
            <Typography
              sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}
            >
              <Typography
                sx={{
                  ...poppins500,
                  // ...fontsize32,
                  fontSize: '16px',
                  color: Colour == 'positive' ? '#10D35E' : '#F93939',
                }}
              >
                {data?.interestedCountVariation === '' || response == -1
                  ? 0
                  : data?.interestedCountVariation}
              </Typography>
              {response === 1 && (
                <Typography>
                  {Colour == 'positive' ? <UpVector /> : <DownVector />}
                  {/* <img
                  src={Colour == "positive" ? VectorUp : VectorDown}
                  width={25}
                  height={25}
                  alt="Live"
                /> */}
                </Typography>
              )}
            </Typography>
          </Typography>
          <Typography style={{ ...gray }} sx={{ ...poppins400, ...fontsize15 }}>
            Variation
          </Typography>
        </Typography>
        <Typography sx={centerContent}>
          <Typography sx={{ ...poppins600, ...fontsize32 }}>
            {data?.marketAvgInterestedCount === '' || response == -1
              ? 0
              : data?.marketAvgInterestedCount.toFixed(2)}
          </Typography>
          <Typography style={{ ...gray }} sx={{ ...poppins400, ...fontsize15 }}>
            Market Avg
          </Typography>
        </Typography>
      </Typography>
      {showProgressBar ? (
        <Grid
          sx={centerContent}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            textAlign: 'revert',
            justifyContent: 'space-between',
            backgroundColor: '#FBFAFE',
            padding: '5px 0px',
            marginBottom: '10px',
          }}
        >
          <Grid
            xs={3}
            style={{
              alignItems: 'center',
            }}
            sx={displayFlexColumn}
          >
            {/* <Typography sx={displayFlex}>
              <ArrowDown height={9} width={9} />
            </Typography>
            <Typography>
              <Green />
              <Yellow />
              <Red />
            </Typography> */}
            {/* <RateIcon/> */}
            <Typography
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: '-15px',
                // gap:"-5px"
                // padding:"10px"
              }}
            >
              <Typography>
                <img
                  src={ArrowDownIcon}
                  alt="Arrowdown"
                  style={{ marginTop: '12px' }}
                />
              </Typography>
              <Grid sx={{ display: 'flex' }}>
                <Typography
                  sx={{
                    height: '10px',
                    width: '12px',
                    background: '#3DD856',
                    borderTopLeftRadius: '5px',
                    borderBottomLeftRadius: '5px',
                  }}
                ></Typography>
                <Typography
                  sx={{ height: '10px', width: '12px', background: '#EBCB38' }}
                ></Typography>
                <Typography
                  sx={{
                    height: '10px',
                    width: '12px',
                    background: '#E45857',
                    borderTopRightRadius: '5px',
                    borderBottomRightRadius: '5px',
                  }}
                ></Typography>
              </Grid>
            </Typography>
          </Grid>
          <Grid
            style={{ color: '#000000' }}
            sx={{ ...poppins300, ...fontsize10 }}
            xs={9}
          >
            The accuracy of this estimate range is rate
            <span>
              <strong style={{ fontWeight: '600' }}> Medium. </strong>
            </span>
            <span>
              <Link href="a" style={{ ...medium }}>
                Learn more.
              </Link>
            </span>
          </Grid>
        </Grid>
      ) : null}
    </Card>
  );
}

function ForecastCardOffer(props) {
  const { title, showProgressBar, data, response } = props;
  const Colour = data?.offerCountIndicator;
  return (
    <Card sx={forCastCard}>
      {title ? (
        <Typography sx={{ ...poppins600, color: '#26344E' }}>
          {title}
        </Typography>
      ) : null}
      <Typography
        sx={displayFlex}
        style={{
          justifyContent: 'space-between',
          padding: '20px 0px',
        }}
      >
        <Typography sx={centerContent}>
          <Typography sx={{ ...poppins600, ...fontsize32 }}>
            {data?.offerCastedCountForecast === '' || response == -1
              ? 0
              : data?.offerCastedCountForecast}
          </Typography>
          <Typography style={{ ...gray }} sx={{ ...poppins400, ...fontsize15 }}>
            {data?.week === '' || response == -1 ? 'week 0' : data?.week}
          </Typography>
        </Typography>
        <Typography
          sx={centerContent}
          style={{
            justifyContent: 'flex-end',
          }}
        >
          <Typography
            sx={{
              ...poppins500,
              ...fontsize16,
              ...bgGreen,
              ...postCntl,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '3px',
              marginBottom: '-7px',
            }}
          >
            <Typography
              sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}
            >
              <Typography
                sx={{
                  ...poppins500,
                  // ...fontsize32,
                  fontSize: '16px',
                  color: Colour == 'positive' ? '#10D35E' : '#F93939',
                }}
              >
                {data?.offerCountVariation === '' || response == -1
                  ? 0
                  : data?.offerCountVariation}
              </Typography>
              {response == 1 && (
                <Typography>
                  {Colour == 'positive' ? <UpVector /> : <DownVector />}
                  {/* <img
                  src={Colour == "positive" ? VectorUp : VectorDown}
                  width={25}
                  height={25}
                  alt="Live"
                /> */}
                </Typography>
              )}
            </Typography>
          </Typography>
          <Typography style={{ ...gray }} sx={{ ...poppins400, ...fontsize15 }}>
            Variation
          </Typography>
        </Typography>
        <Typography sx={centerContent}>
          <Typography sx={{ ...poppins600, ...fontsize32 }}>
            {data?.marketAvgOfferCastedCount === '' || response == -1
              ? 0
              : data?.marketAvgOfferCastedCount.toFixed(2)}
          </Typography>
          <Typography style={{ ...gray }} sx={{ ...poppins400, ...fontsize15 }}>
            Market Avg
          </Typography>
        </Typography>
      </Typography>
      {showProgressBar ? (
        <Grid
          sx={centerContent}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            textAlign: 'revert',
            justifyContent: 'space-between',
            backgroundColor: '#FBFAFE',
            padding: '5px 0px',
            marginBottom: '10px',
          }}
        >
          <Grid
            xs={3}
            style={{
              alignItems: 'center',
            }}
            sx={displayFlexColumn}
          >
            {/* <Typography sx={displayFlex}>
              <ArrowDown height={9} width={9} />
            </Typography>
            <Typography>
              <Green />
              <Yellow />
              <Red />
            </Typography> */}
            {/* <RateIcon/> */}
            <Typography
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: '-15px',
                // gap:"-5px"
                // padding:"10px"
              }}
            >
              <Typography>
                <img
                  src={ArrowDownIcon}
                  alt="Arrowdown"
                  style={{ marginTop: '12px' }}
                />
              </Typography>
              <Grid sx={{ display: 'flex' }}>
                <Typography
                  sx={{
                    height: '10px',
                    width: '12px',
                    background: '#3DD856',
                    borderTopLeftRadius: '5px',
                    borderBottomLeftRadius: '5px',
                  }}
                ></Typography>
                <Typography
                  sx={{ height: '10px', width: '12px', background: '#EBCB38' }}
                ></Typography>
                <Typography
                  sx={{
                    height: '10px',
                    width: '12px',
                    background: '#E45857',
                    borderTopRightRadius: '5px',
                    borderBottomRightRadius: '5px',
                  }}
                ></Typography>
              </Grid>
            </Typography>
          </Grid>
          <Grid
            style={{ color: '#000000' }}
            sx={{ ...poppins300, ...fontsize10 }}
            xs={9}
          >
            The accuracy of this estimate range is rate
            <span>
              <strong style={{ fontWeight: '600' }}> Medium. </strong>
            </span>
            <span>
              <Link href="a" style={{ ...medium }}>
                Learn more.
              </Link>
            </span>
          </Grid>
        </Grid>
      ) : null}
    </Card>
  );
}

ForecastCardInspected.defaultProps = {
  showProgressBar: true,
};

ForecastCardInspected.propTypes = {
  title: PropTypes.string.isRequired,
  showProgressBar: PropTypes.bool,
};

ForecastCardInterested.defaultProps = {
  showProgressBar: true,
};

ForecastCardInterested.propTypes = {
  title: PropTypes.string.isRequired,
  showProgressBar: PropTypes.bool,
};

ForecastCardOffer.defaultProps = {
  showProgressBar: true,
};

ForecastCardOffer.propTypes = {
  title: PropTypes.string.isRequired,
  showProgressBar: PropTypes.bool,
};

// export default ForecastCard;

export { ForecastCardInspected, ForecastCardInterested, ForecastCardOffer };
